// extracted by mini-css-extract-plugin
export default {"form-buttons":"FormHeader_form-buttons__CnnfL","btn-with-margin":"FormHeader_btn-with-margin__9Wilw"};